// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const version = {
    suffix: "dirty",
    number: "1.0.0"
};
